'use strict';

var __chunk_1 = require('./chunk-ba04ad2f.js');

function prepend(a, bs) {
  return __chunk_1.isString(bs) ? a + bs : [a].concat(bs);
}

module.exports = prepend;
